import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-difference",
  templateUrl: "./med-icon-difference.component.html",
})
export class MedIconDifferenceComponent extends SvgMixinComponent {}
